export default __webpack_public_path__ + "static/media/download.276cb6b2.svg";